export default __webpack_public_path__ + "static/Montserrat-Regular-df7b9b6f89ccf3a354d32e88733486de.woff2";